import {createConsentManagement} from "@codegouvfr/react-dsfr/consentManagement";

export const {
    ConsentBannerAndConsentManagement,
    FooterConsentManagementItem,
    FooterPersonalDataPolicyItem,
    useConsent
} = createConsentManagement({
    /*
        Can be an object or a function that take the current language as argument.
        You should here describe the finalities of the cookies you use so that the user can choose to accept or not.
    */
    finalityDescription: ({ lang }) => ({
        analytics: {
            title: "Analyse",
            description: "Nous utilisons des cookies pour mesurer l’audience de notre site et améliorer son contenu."
        }
    }),


    /*
    If you have a page that describe your personal data policy, you can link to it here.
    Like any other *LinkProps you can turn it into a button by using { href: "#", onClick: ... }
    (if you are using react-router it will be `to` instead of `href`).
    */
    personalDataPolicyLinkProps: {
        to: "/politique-cookies",
        title: "Politique de cookies"
    },
    /*
    This optional callback is called when the user take stance on what he accept and refuse.
    It gives you the opportunity to perform asynchronous actions before the user can continue to navigate.

    */
    // consentCallback : async ()=> { }
});